import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Spinner,
  Button,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

import { getBanner } from '../../actions/BannerAction';
import { DELETE_BANNER, GET_TOKEN } from 'utils';

import swal from 'sweetalert';
import axios from 'axios';
import { logOutUser } from 'actions/AuthAction';
import jwt_decode from 'jwt-decode';

export default function ListBanner() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getBannerError, getBannerLoading, getBannerResult } = useSelector(
    (state) => state.BannerReducer
  );

  // auth

  const [token, setToken] = useState('');
  const [nama, setNama] = useState('');
  const [username, setUsername] = useState('');
  const [akses, setAkses] = useState('');
  const [expire, setExpire] = useState('');
  const [idAdmin, setIdAdmin] = useState('1');
  const [accessToken, setAccessToken] = useState('');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token', {
        credential: 'include',
      });
      setToken(response.data);
      const decoded = jwt_decode(response.data.accessToken);
      setAccessToken(response.data.accessToken);
      setNama(decoded.nama);
      setUsername(decoded.username);
      setAkses(decoded.akses.split(','));
      setExpire(decoded.exp);
      setIdAdmin(decoded.idAdmin);
    } catch (error) {
      if (error.response) {
        dispatch(logOutUser(history));
        history.push('/');
      }
    }
  };

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.get(GET_TOKEN + '/token', {
          credential: 'include',
        });
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setNama(decoded.nama);
        setUsername(decoded.username);
        setAkses(decoded.akses);
        setIdAdmin(decoded.idAdmin);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  //auth

  useEffect(() => {
    dispatch(getBanner());
    refreshToken();
  }, []);

  const removeData = async (id) => {
    try {
      await axios.delete(DELETE_BANNER + `${id}`, {
        credential: 'include',
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      swal('Sukses!', 'Banner berhasil dihapus', 'success');
      history.push('/admin');
      history.push('/admin/banner');
    } catch (error) {
      swal('Failed!', 'Forbiden', 'error');
    }
  };

  return (
    <div className='content'>
      <Row>
        <Col md='12'>
          <Card>
            <CardHeader>
              <CardTitle tag='h4'>List Banner</CardTitle>
              <Link
                to={'/admin/banner/tambah/' + idAdmin}
                className='btn btn-primary float-right'
              >
                Tambah Banner
              </Link>
            </CardHeader>
            <CardBody style={{ overflowX: 'auto' }}>
              <Table>
                <thead className='text-primary'>
                  <tr>
                    <th>Id</th>
                    <th>gambar</th>
                    <th>nama</th>
                    <th>page</th>
                    <th>keterangan</th>
                    <th>Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  {getBannerResult ? (
                    Object.keys(getBannerResult).map((key) => (
                      <tr key={key}>
                        <td>{getBannerResult[key].id}</td>
                        <td>
                          <img
                            src={getBannerResult[key].gambar.split(',')[0]}
                            width='200'
                            alt={getBannerResult[key].nama}
                          />
                        </td>
                        <td>{getBannerResult[key].nama}</td>
                        <td>{getBannerResult[key].page}</td>
                        <td>{getBannerResult[key].keterangan} </td>
                        <td>
                          <Link
                            className='btn btn-warning'
                            to={
                              '/admin/banner/edit/' +
                              getBannerResult[key].id +
                              ',' +
                              idAdmin
                            }
                          >
                            <i className='nc-icon nc-ruler-pencil'></i> Edit
                          </Link>
                        </td>
                        <td>
                          <Button
                            color='danger'
                            className='ml-2'
                            onClick={() => removeData(getBannerResult[key].id)}
                          >
                            <i className='nc-icon nc-basket'></i> Hapus
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : getBannerLoading ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        <Spinner color='primary' />
                      </td>
                    </tr>
                  ) : getBannerError ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        {getBannerError}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan='6' align='center'>
                        Data Kosong
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
